import styled from 'styled-components'

import { ArrowLeft } from '@/components/shared/icons/ArrowLeft'
import { ArrowRight } from '@/components/shared/icons/ArrowRight'

export const BUTTON_HEIGHT = 68
export const BUTTON_WIDTH = 68
export const BUTTON_BORDER_RADIUS = '50%'

const StyledCircleWithArrow = styled.button`
  align-items: center;
  background-color: #e3f0ec;
  border: none;
  border-radius: ${BUTTON_BORDER_RADIUS};
  cursor: pointer;
  display: flex;
  justify-content: center;
  height: ${BUTTON_HEIGHT}px;
  outline: none;
  width: ${BUTTON_WIDTH}px;
`

interface CircleWithArrowButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  direction: 'left' | 'right'
}

export const CircleWithArrowButton: React.FC<CircleWithArrowButtonProps> = (props) => {
  const isLeft = props.direction === 'left'

  return (
    <StyledCircleWithArrow {...props} type="button" aria-label={isLeft ? 'Scroll left' : 'Scroll right'}>
      {isLeft ? <ArrowLeft /> : <ArrowRight />}
    </StyledCircleWithArrow>
  )
}
